<form [formGroup]="formGroup">
  <div class="row">
    <div class="col-12 col-lg-4">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'Postcode' | translate }}</mat-label>
        <input
          matInput
          formControlName="postcode"
          autocomplete="postcode"
          type="text"
          placeholder="00-000"
          minlength="6"
          maxlength="6"
          [matAutocomplete]="auto"
          postCodeMask
          required
          />
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayValue" (optionSelected)="setSelectedPostCode($event)">
            @for (option of listOfPostCodes$ | async; track option) {
              <mat-option [value]="option">
                {{ option.Name }} - {{ option.City.Name }} {{ option.City.Name !== option.City.Commune.Name ? '- ' + option.City.Commune.Name : '' }}
              </mat-option>
            }
          </mat-autocomplete>
          @if (postcodeControl.invalid && postcodeControl.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-12 col-lg-8">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'PostOffice' | translate }}</mat-label>
          <input matInput formControlName="postOffice" type="text" autocomplete="postOffice" [placeholder]="'PostOffice' | translate" />
          @if (postOfficeControl.invalid && postOfficeControl.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg-12">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'District' | translate }}</mat-label>
          <mat-select id="district" formControlName="district">
            @for (district of listOfDistricts$ | async; track district) {
              <mat-option [value]="district.Id"> {{ district.Name }}</mat-option>
            }
          </mat-select>
          @if (districtControl.invalid && districtControl.touched) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Poviat' | translate }}</mat-label>
          <input
            matInput
            id="poviat"
            formControlName="poviat"
            type="text"
            placeholder="{{ 'Poviat' | translate }}"
            [matAutocomplete]="autocompletePoviat"
            required
            />
            <mat-autocomplete #autocompletePoviat="matAutocomplete" [displayWith]="displayValue">
              @for (poviat of listOfPoviats$ | async; track poviat) {
                <mat-option [value]="poviat">
                  {{ poviat.Name }}
                </mat-option>
              }
            </mat-autocomplete>
            @if (poviatControl.invalid && poviatControl.touched) {
              <mat-error>
                {{ 'InvalidField' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Commune' | translate }}</mat-label>
            <input
              matInput
              id="commune"
              formControlName="commune"
              type="text"
              [placeholder]="'Commune' | translate"
              [matAutocomplete]="autocompleteCity"
              required
              />
              <mat-autocomplete #autocompleteCity="matAutocomplete" [displayWith]="displayValue">
                @for (commune of listOfCommunes$ | async; track commune) {
                  <mat-option [value]="commune">
                    {{ commune.Name }}
                  </mat-option>
                }
              </mat-autocomplete>
              @if (communeControl.invalid && communeControl.touched) {
                <mat-error>
                  {{ 'InvalidField' | translate }}
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-lg-4">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'City' | translate }}</mat-label>
              <input
                matInput
                id="city"
                formControlName="city"
                type="text"
                [placeholder]="'City' | translate"
                [matAutocomplete]="autocompleteCity"
                required
                />
                <mat-autocomplete #autocompleteCity="matAutocomplete" [displayWith]="displayValue">
                  @for (city of listOfCities$ | async; track city) {
                    <mat-option [value]="city">
                      {{ city.Name }}
                    </mat-option>
                  }
                </mat-autocomplete>
                @if (cityControl.invalid && cityControl.touched) {
                  <mat-error>
                    {{ 'InvalidField' | translate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="col-12 col-lg-4">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Street' | translate }}</mat-label>
                <input
                  matInput
                  id="street"
                  formControlName="street"
                  type="text"
                  placeholder="{{ 'Street' | translate }}"
                  [matAutocomplete]="autocompleteStreet"
                  />
                  <mat-autocomplete #autocompleteStreet="matAutocomplete" [displayWith]="displayValue">
                    @for (street of listOfStreets$ | async; track street) {
                      <mat-option [value]="street">
                        {{ street.Name }}
                      </mat-option>
                    }
                  </mat-autocomplete>
                  @if (streetControl.invalid && streetControl.touched) {
                    <mat-error>
                      {{ 'InvalidField' | translate }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col-6 col-lg-2">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'HouseNumber' | translate }}</mat-label>
                  <input matInput formControlName="houseNumber" type="text" [placeholder]="'HouseNumber' | translate" autocomplete="houseNumber" />
                  @if (houseNumberControl.invalid && houseNumberControl.touched) {
                    <mat-error>
                      {{ 'InvalidField' | translate }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>

              <div class="col-6 col-lg-2">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'ApartmentNumber' | translate }}</mat-label>
                  <input matInput formControlName="apartmentNumber" type="text" autocomplete="apartmentNumber" [placeholder]="'ApartmentNumber' | translate" />
                  @if (apartmentNumberControl.invalid && apartmentNumberControl.touched) {
                    <mat-error>
                      {{ 'InvalidField' | translate }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </form>
